export default "__VITE_PUBLIC_ASSET__21a219eb__"